<script setup lang="ts">
import type { ECOption } from '@/plugins/echarts'

const data = [
  ['2022-07-15', 111],
  ['2022-07-16', 64],
  ['2022-07-17', 69],
  ['2022-07-18', 88],
  ['2022-07-19', 77],
  ['2022-07-20', 83],
  ['2022-07-21', 111],
  ['2022-07-22', 57],
  ['2022-07-23', 55],
  ['2022-07-24', 60],
]

const option: ECOption = {
  backgroundColor: 'transparent',
  dataset: { source: data },
  visualMap: {
    show: false,
    type: 'continuous',
    min: 0,
    max: 400,
  },
  tooltip: {
    trigger: 'axis',
  },
  grid: {
    top: 20,
    left: '2%',
    right: '2%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: {
    type: 'time',
    axisLabel: {
      rotate: 45, // Rotate the labels by 45 degrees
      formatter: function (value) {
        const date = new Date(value);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${day}/${month}`;
      },
    },


  },
  yAxis: {
    type: 'value',
  },
  series: [
    {
      name: 'value',
      type: 'line',
      showSymbol: false,
      lineStyle: {
        width: 2,
      },
    },
  ],
}
</script>

<template>
  <v-chart style="min-width: 200px;min-height: 200px;" :option="option" autoresize />
</template>
